export const getEnumKeyByValue = <T extends Record<string, string>>(enumObj: T, value: string): keyof T | undefined => {
    return Object.keys(enumObj).find((key) => enumObj[key] === value);
};

export const copyAndExcludeProperty = <T>(object: T, key: keyof T): T => {
    const copied_object = { ...object };
    delete copied_object[key];
    return copied_object;
};

export const compareObjectsAndReturnDifferentFields = <T extends Record<string, unknown>>(
    initial_values: T,
    new_values: T
): Set<keyof T> => {
    const all_keys = Object.keys(initial_values);

    return new Set(all_keys.filter((key) => initial_values[key] !== new_values[key]));
};

export const trimWhiteSpacesRecursively = (obj: Record<string, unknown>): void => {
    for (const key in obj) {
        if (typeof obj[key] === 'string') {
            obj[key] = obj[key].trim();
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
            trimWhiteSpacesRecursively(obj[key] as Record<string, unknown>);
        }
    }
};
